module.exports = __webpack_public_path__ + "static/subset-UniNeueHeavy-8456e78816d2d0c123eb588b4c4d375f.woff2";